import logger from '../../config/app.logger';
import loadScript from '../../utils/loadScript';

import { getExtendedLogger } from '../Logger';

import type { TZipy } from './types';

import { LOGGER_NAME, ZIPY_SDK_URL } from './constants';

declare global {
  interface Window {
    zipy: TZipy;
  }
}

const log = getExtendedLogger(LOGGER_NAME, logger);

function init(userId: string, extra: { [key: string]: string }) {
  if (!(window.zipy && process.env.ZIPY_PROJECT_ID)) {
    log('zipy not loaded, skipping initialisation');
    return;
  }

  window.zipy.init(process.env.ZIPY_PROJECT_ID!);

  log('initialised');

  return new Promise(function (resolve) {
    setTimeout(function () {
      window.zipy.identify(userId, extra);
      log('user identity set');
      resolve('done');
    }, 200);
  });
}

async function load() {
  if (process.env.ZIPY_PROJECT_ID) {
    log(`loading zipy with project - ${process.env.ZIPY_PROJECT_ID}`);
    try {
      await loadScript({ url: ZIPY_SDK_URL, defer: true });
      log('loaded, ready for initialisation');
    } catch (error) {
      log('loading failed');
    }
  } else {
    log('ZIPY_PROJECT_ID is not defined, skipping loading');
  }
}

export { init, load };
